<template>
  <section id="contact" class="contact-area ptb_190">
    <div class="container">
      <div class="row justify-content-between align-items-center">
        <div class="col-12 col-lg-5">
          <!-- Section Heading -->
          <div class="section-heading text-center mb-3">
            <h2>{{$t('contact.contactUs')}}</h2>
            <!-- <p class="d-none d-sm-block mt-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati dignissimos quae quo ad iste ipsum officiis deleniti asperiores sit.</p>
                        <p class="d-block d-sm-none mt-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati.</p> -->
          </div>
          <!-- Contact Us -->
          <div class="contact-us">
            <ul>
              <!-- Contact Info -->
              <li
                class="
                  contact-info
                  color-1
                  bg-hover
                  active
                  hover-bottom
                  text-center
                  p-5
                  m-3
                "
              >
                <span><i class="fas fa-mobile-alt fa-3x"></i></span>
                <a class="d-block my-2" href="#">
                  <h3>+66 (0) 621966196</h3>
                </a>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
              </li>
              <!-- Contact Info -->
              <li
                class="
                  contact-info
                  color-3
                  bg-hover
                  active
                  hover-bottom
                  text-center
                  p-5
                  m-3
                "
              >
                <span><i class="fas fa-envelope-open-text fa-3x"></i></span>
                <a class="d-none d-sm-block my-2" href="#">
                  <h3>spdevsolution@gmail.com</h3>
                </a>
                <a class="d-block d-sm-none my-2" href="#">
                  <h3>mail@your company.com</h3>
                </a>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-lg-6 pt-4 pt-lg-0">
          <!-- Contact Box -->
          <div class="contact-box text-center">
            <!-- Contact Form -->
            <form @submit.prevent="onFormSubmit">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      id="project"
                      class="form-control"
                      v-model="user.project"
                      placeholder="Project"
                      required="required"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="text"
                      id="name"
                      class="form-control"
                      v-model="user.name"
                      placeholder="Firstname - Lastname"
                      required="required"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="text"
                      id="company"
                      class="form-control"
                      v-model="user.company"
                      placeholder="Company Name"
                      required="required"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      id="email"
                      class="form-control"
                      v-model="user.email"
                      placeholder="Email"
                      required="required"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="text"
                      id="phone"
                      class="form-control"
                      v-model="user.phone"
                      placeholder="Phone"
                      required="required"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <textarea
                      class="form-control"
                      id="message"
                      placeholder="More Information"
                      v-model="user.message"
                    ></textarea>
                  </div>
                </div>
                <div class="col-12">
                  <button class="btn btn-bordered active btn-block mt-3">
                    <span class="text-white pr-3"
                      ><i class="fas fa-paper-plane"></i></span
                    >Send
                  </button>
                </div>
              </div>
              
            </form>
            <p class="form-message contact-area ptb_190"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { db } from "../../firebaseInit";

export default {
  data() {
    return {
      user: {
      },
    };
  },
  methods: {
    onFormSubmit(event) {
      event.preventDefault();
      db.collection("users")
        .add(this.user)
        .then(() => {
          alert("User successfully created!");
          this.user.project = "";
          this.user.name = "";
          this.user.company = "";
          this.user.email = "";
          this.user.phone = "";
          this.user.message = "";
        })
        .catch((error) => {
        //   console.log(error);
        });
    },
  }
};
</script>

<style>
</style>